function wrapElement(element, wrapper) {
    element.parentNode.insertBefore(wrapper, element);
    wrapper.appendChild(element);
}

function appendElement(parent, child) {
    parent.appendChild(child);
}

function prependElement(parent, child) {
    if (parent.childNodes.length > 0) {
        parent.insertBefore(child, parent.childNodes[0]);
    }
    else {
        parent.appendChild(child);
    }
}

function createElement(tagName, parent) {
    const el = document.createElement(tagName);

    if (parent) {
        parent.appendChild(el);
    }

    return el;
}

function removeElement(element) {
    element.parentNode.removeChild(element);
}

function getNextSibling(element, selector) {

    // Get the next sibling element
    let sibling = element.nextElementSibling;

    // If there's no selector, return the first sibling
    if (!selector)
        return sibling;

    // If the sibling matches our selector, use it
    // If not, jump to the next sibling and continue the loop
    while (sibling) {
        if (sibling.matches(selector))
            return sibling;

        sibling = sibling.nextElementSibling
    }

}

function getPrevSibling(element, selector) {

    // Get the next sibling element
    var sibling = element.previousElementSibling;

    // If there's no selector, return the first sibling
    if (!selector)
        return sibling;

    // If the sibling matches our selector, use it
    // If not, jump to the next sibling and continue the loop
    while (sibling) {
        if (sibling.matches(selector))
            return sibling;

        sibling = sibling.previousElementSibling;
    }

}

function setStyles(element, styles) {
    for (let s in styles) {
        element.style[s] = styles[s];
    }
}

function addEventListeners(nodeListOrSelector, eventName, fn, useCapture = false) {

    if (typeof nodeListOrSelector === 'string') {
        nodeListOrSelector = document.querySelectorAll(nodeListOrSelector);
    }

    if (!nodeListOrSelector)
        return;

    for (var i = 0, len = nodeListOrSelector.length; i < len; i++) {
        nodeListOrSelector[i].addEventListener(eventName, fn, useCapture);
    }
}

function removeEventListeners(nodeListOrSelector, eventName, fn) {

    if (typeof nodeListOrSelector === 'string') {
        nodeListOrSelector = document.querySelectorAll(nodeListOrSelector);
    }

    if (!nodeListOrSelector)
        return;

    for (var i = 0, len = nodeListOrSelector.length; i < len; i++) {
        nodeListOrSelector[i].removeEventListener(eventName, fn);
    }
}

function querySelectorLast(selector, root = document) {
    const elements = root.querySelectorAll(selector);

    if (elements === null || elements.length === 0)
        return null;

    return elements[elements.length - 1];
}

export {
    appendElement,
    prependElement,
    createElement,
    getNextSibling,
    getPrevSibling,
    wrapElement,
    removeElement,
    setStyles,
    addEventListeners,
    removeEventListeners,
    querySelectorLast
};